const QUESTIONS = [
	{
		question: "Preciso instalar alguma coisa?",
		answer:
			"Não. O Obra Todo Dia funciona no navegador do computador e do celular. A equipe do canteiro usa pelo celular mesmo, com a câmera para fotos e vídeos.",
	},
	{
		question: "Como começo a usar?",
		answer:
			"Entre na lista de espera com seu e-mail. Quando chegar sua vez, você recebe um convite, cria a conta da construtora e cadastra o primeiro canteiro e a primeira obra.",
	},
	{
		question:
			"O PDF do Relatório de Obra sai com a marca da minha construtora?",
		answer:
			"Sim. Você envia o logo da construtora e define o responsável técnico com o CREA. Os dois aparecem em todo Relatório de Obra gerado.",
	},
	{
		question: "E se eu precisar corrigir um Relatório de Obra já finalizado?",
		answer:
			"Você abre uma revisão. O relatório mantém o mesmo número, ganha uma nova revisão e a versão anterior continua guardada.",
	},
	{
		question: "O cliente vê tudo o que a equipe publica?",
		answer:
			"Não. Cada pessoa é convidada para uma obra com uma função, e o que ela vê depende dessa função. O cliente acompanha a obra dele e mais nada.",
	},
];

export function Faq() {
	return (
		<section data-slot="band" id="perguntas">
			<div data-slot="faq">
				<div data-slot="section-intro">
					<p data-slot="eyebrow">Perguntas</p>
					<h2 data-slot="section-title">Antes de entrar.</h2>
				</div>
				<div>
					{QUESTIONS.map((item) => (
						<details key={item.question} data-slot="faq-item">
							<summary data-slot="faq-question">{item.question}</summary>
							<p data-slot="faq-answer">{item.answer}</p>
						</details>
					))}
				</div>
			</div>
		</section>
	);
}
